/**
 * src/main.tsx
 * =============================================================================
 * Punto de entrada de Vite. Monta la aplicación React en #root.
 *
 * El side-effect de importar '@/lib/i18n' inicializa i18next antes de que
 * cualquier componente llame a `useTranslation()`. Mantener esa línea *antes*
 * de importar App o cualquier pieza de UI.
 *
 * StrictMode activado: ayuda a detectar efectos duplicados y patrones obsoletos
 * en desarrollo. No afecta al build de producción.
 * =============================================================================
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@/lib/i18n'
import '@/index.css'
import { initSentry } from '@/lib/sentry'
import { App } from '@/App'

// Sentry DEBE inicializarse antes de montar React para capturar errores
// del propio render. Si no hay DSN configurado, hace noop (ver lib/sentry.ts).
initSentry()

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('No se encontró el elemento raíz #root en index.html')
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
